import numeral from 'numeral'
import moment from 'moment'

export const isNull = (val) => {
  return !!(val === undefined || val === null || val === '')
}

export const toInt = (val) => {
  if (isNull(val) || isNaN(+val)) return '0'
  else return numeral(val).format('0')
}

export const toDigi = (val) => {
  if (isNull(val) || isNaN(+val)) return '0'
  else return numeral(val).format('0,0')
}

export const precision = (val) => {
  return Math.floor(val * 100) / 100
}

export const toMoney = (val) => {
  if (isNull(val) || isNaN(+val)) return '0'
  else return numeral(val).format('0,0.00')
}

export const toText = (val) => {
  if (isNull(val)) return '-'
  else return val
}

export const toDatetime = (val) => {
  if (isNull(val)) return '-'

  const mm = moment(val)
  const year = mm.year() + 543
  const date = mm.format('DD/MM')
  const time = mm.format('HH:mm')
  return `${date}/${year} เวลา ${time} น.`
}

export const toShortDay = (val) => {
  if (isNull(val)) return '-'
  else if (typeof val === 'string') return val.slice(0, 3)
  else return moment(val).format('DD')
}

export const toShortMonth = (val) => {
  if (isNull(val)) return '-'
  else if (typeof val === 'string') return val.slice(0, 3)
  else return moment(val).format('MM')
}

export const toDate = (val) => {
  if (isNull(val)) return '-'
  else return moment(val).format('DD/MM/YYYY')
}

export const toTime = (val) => {
  if (isNull(val)) return '-'
  else return moment(val).format('HH:mm')
}

export const toPattern = (value, pattern) => {
  if (!value) return ''

  let valueIndex = 0
  const list = String(pattern).split('')
  const newList = []

  for (let i = 0; i < pattern.length && valueIndex < value.length; i++) {
    if (list[i] === 'x') {
      newList.push(value[valueIndex++])
    } else {
      newList.push(list[i])
    }
  }

  return newList.join('')
}

export const clearPattern = (text = '', ch = '-') => {
  const value = (text || '').replaceAll(ch, '')

  return value
}

export const toMobile = (text) => {
  const mobile = (text || '').replaceAll('-', '')
  return toPattern(mobile, 'xxx-xxx-xxxx')
}

export const replaceAll = (text, ch, to = '') => {
  const val = `${text || ''}`
  const c = `${ch || ''}`

  return val.replaceAll(c, to)
}

export const removeZeroPrefix = (phoneNumber) => {
  return phoneNumber.replace(/^0+/, '')
}

export const formatMobilePattern = (phoneNumber) => {
  const str = phoneNumber.toString()
  let result = ''

  if (str.length <= 4) {
    return str
  }

  let firstPartEnd = str.length % 4 || 4

  result += str.slice(0, firstPartEnd)

  for (let i = firstPartEnd; i < str.length; i += 4) {
    result += ' ' + str.slice(i, i + 4)
  }

  return result
}
